
export default {
  productData: {
    serialNumber: 'DA-MME-010',
    name: 'Massivholzdecke mit Estrich l Aufbau 10',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 60',
          value: 'w-60'
        },
        {
          type: 'insulation',
          title: { de: 'Mineralwolldämmplatte MW<br>(<i>s‘</i> ≤ 8 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 30',
          value: 'm-30'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB 100 gebundene Schüttung (<i>m‘</i> ≥ 108,5 kg/m<sup>2</sup>)' },
          output: '≥ 65',
          value: 'scsb100-65'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Brettsperrholzdecke' },
          output: 120,
          value: 'bsh-120'
        }
      ],
      sum: {
        output: '275', value: 275
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '46 (-2; 6)',
        value: 46
      },
      soundReductionIndex: { // Rw
        output: '75 (-1; -6)',
        value: 75
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,44',
        value: 0.44
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '318 [kg/m²]'
      }
    }
  },
  image: 'da-mme-010.svg',
  pdf: 'Massivholzdecke-mit-Estrich-Aufbau-10-DA-MME-010-Rev01.pdf'
}
